/* tslint:disable:max-line-length */
import React from 'react'

interface Props {
    width?: number
    height?: number,
    fill?: string,
    stroke?: string
}

interface State {}

export default class SearchIcon extends React.Component<Props, State> {

    public render() {

        let {
            fill,
            stroke = '#FFF',
            width = 20,
            height = 20
        } = this.props

        return (
            <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
                <path fillRule="evenodd" stroke={stroke} fill={fill} d="M6.75 1C3.575 1 1 3.457 1 6.481c0 3.026 2.574 5.482 5.75 5.482 1.603 0 3.05-.63 4.095-1.635l4.857 4.624c.07.065.18.064.248-.002a.16.16 0 0 0-.003-.236l-4.862-4.63c.885-.965 1.428-2.223 1.428-3.603C12.513 3.457 9.93 1 6.75 1zm0 .332c2.99 0 5.414 2.304 5.414 5.15 0 2.846-2.423 5.148-5.413 5.148-2.989 0-5.402-2.302-5.402-5.149 0-2.845 2.414-5.149 5.402-5.149z"/>
            </svg>
        )
    }
}



// WEBPACK FOOTER //
// ./src/_assets/icons/Search.tsx